var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopNavPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 472,
    width: 96,
    height: 96
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-43 -472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89 482C69 483 53 499.8 53 520 53 541 70 558 91 558 100.5 558 109.4 554.6 116.4 548.2L89 520.8 89 482Z",
    fill: "#ffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 482 93 518 128.9 518C127.9 498.5 112.4 483 93 482Z",
    fill: "#ffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8 522 119.2 545.4C125.1 538.9 128.5 530.7 128.9 522L95.8 522Z",
    fill: "#ffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopNavPieChart);
export default __webpack_public_path__ + "static/media/top-nav-pie-chart.6d8ed6f19a59de2c9b193f4ca462d54f.svg";
export { ForwardRef as ReactComponent };